if (!customElements.get('jp-size-tables')) {
  customElements.define(
    'jp-size-tables',
    class JPSizeTables extends HTMLElement {
      constructor() {
        super();
      }
      
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.tables = this.querySelectorAll('table');
        this.jpSizeTables = this.querySelectorAll('.jp-size-table');
        this.currentVariantOptions = this.dataset.currentVariantOptions.split(', ');

        this.filterTablesOnPageLoad();
        this.filterTables();
        this.highlightActiveRowAndColumn();
        this.changeUnitSwitch();

        document.addEventListener('variant:changed', (event) => this.filterTablesBasedOnVariantChange(event));
      }

      filterTables() {
        // Compare the table's primaryFilterValue and secondaryFilterValue with the primaryFilter and secondaryFilter
        // If they match, show the table, otherwise hide it
        const normalize = str =>
          str?.trim().toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9\-]/g, '');

        const primaryFilter = normalize(this.dataset.primaryFilter);
        const secondaryFilter = normalize(this.dataset.secondaryFilter);

        this.jpSizeTables.forEach(jpSizeTable => {
          const primaryFilterValue = normalize(jpSizeTable.dataset.primaryFilterValue);
          const secondaryFilterValue = normalize(jpSizeTable.dataset.secondaryFilterValue);

          const shouldShow = (primaryFilter === primaryFilterValue) && (secondaryFilter === secondaryFilterValue);
          jpSizeTable.style.display = shouldShow ? 'block' : 'none';
        });
      }

      highlightActiveRowAndColumn() {
        this.tables.forEach(table => {
          table.querySelectorAll('td:not([data-key="true"])').forEach(cell => {
            cell.addEventListener('mouseenter', () => {
              const colIndex = cell.getAttribute('data-col');
              const row = cell.closest('tr');
              
              // Highlight column
              table.querySelectorAll(`[data-col="${colIndex}"]`).forEach(el => {
                el.classList.add('highlight');
              });

              // Highlight row
              row.querySelectorAll('td').forEach(el => {
                el.classList.add('highlight');
              });
            });

            cell.addEventListener('mouseleave', () => {
              const colIndex = cell.getAttribute('data-col');
              const row = cell.closest('tr');
              
              // Remove highlight from column
              table.querySelectorAll(`[data-col="${colIndex}"]`).forEach(el => {
                el.classList.remove('highlight');
              });

              // Remove highlight from row
              row.querySelectorAll('td').forEach(el => {
                el.classList.remove('highlight');
              });
            });
          });
        });
      }

      changeUnitSwitch() {
        this.tds = this.querySelectorAll('td:not([data-key="true"])');
        this.changeUnitSwitch = this.querySelector('jp-switch input');
        this.changeUnitSwitch.addEventListener('change', () => {
          this.tds.forEach(td => {
            if(this.changeUnitSwitch.checked) {
              const converted = this.convertInchToCm(td.dataset.originalValue);
              if (converted) td.innerText = converted;
            } else {
              td.innerText = td.dataset.originalValue + '"';
            }
          });
        });
      }

      convertInchToCm(inchStr) {
        // 19 3/8"
        const cleaned = inchStr.replace('"', '').trim();
        const parts = cleaned.split(' '); // ["19", "3/8"]
        let inch = 0;

        if (parts.length === 2) {
          const [whole, frac] = parts;
          const [numerator, denominator] = frac.split('/');
          if (denominator && !isNaN(whole) && !isNaN(numerator) && !isNaN(denominator)) {
            inch = parseInt(whole) + (parseInt(numerator) / parseInt(denominator));
          } else {
            return null;
          }
        } else if (parts.length === 1) {
          inch = parseFloat(parts[0]);
        } else {
          return null;
        }

        const cm = inch * 2.54;
        const rounded = Math.round(cm * 2) / 2;
        return rounded + ' cm';
      }

      filterTablesOnPageLoad() {
        this.bibo(this.currentVariantOptions);
      }
      
      filterTablesBasedOnVariantChange(event) {
        this.bibo(event.detail.variant.options);
      }

      bibo(options) {
        const normalize = str =>
          str?.trim().toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9\-]/g, '');

        const primaryFilterValues = this.dataset.primaryFilterValues?.split(', ').map(normalize);
        const secondaryFilterValues = this.dataset.secondaryFilterValues?.split(', ').map(normalize);

        options?.forEach(option => {
          const normalizedOption = normalize(option);

          if(primaryFilterValues?.includes(normalizedOption)) {
            this.dataset.primaryFilter = option;

            Array.from(this.querySelectorAll('input')).find(input =>
              normalize(input.value) === normalizedOption && (input.checked = true)
            );

            this.filterTables();
          }

          if(secondaryFilterValues?.includes(normalizedOption)) {
            this.dataset.secondaryFilter = option;

            Array.from(this.querySelectorAll('input')).find(input =>
              normalize(input.value) == normalizedOption && (input.checked = true)
            );

            this.filterTables();
          }
        });
      }
      
    }
  );
}

if (!customElements.get('jp-tabs')) {
  customElements.define(
    'jp-tabs',
    class JPTabs extends HTMLElement {
      constructor() {
        super();
      }
      
      connectedCallback() {
        this.tabs = this.querySelectorAll('input');
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => {
            this.tabClickHandler(tab, index);
            this.setTabDisplay();
          });
        });
      }

      tabClickHandler(tab) {
        if(tab.checked) {
          if(this.dataset.type == 'primary-filter') {
            this.dataset.primaryFilter = tab.value;
            this.closest('jp-size-tables').dataset.primaryFilter = tab.value;
            this.closest('jp-size-tables').filterTables();
          } else if(this.dataset.type == 'secondary-filter') {
            this.dataset.secondaryFilter = tab.value;
            this.closest('jp-size-tables').dataset.secondaryFilter = tab.value;
            this.closest('jp-size-tables').filterTables();
          }
        }
      }

      setTabDisplay() {
        this.keysAndDescriptions = this.querySelector('.jp-size-tables__filter-keys-and-descriptions');
        if (!this.keysAndDescriptions) return;

        this.keys = this.keysAndDescriptions.querySelectorAll('h3 span');
        this.descriptions = this.keysAndDescriptions.querySelectorAll('p span');

        if(this.keys.length > 1) {
          this.tabs.forEach((tab, index) => {
            const show = tab.checked;
            if (show) {
              this.keys[index]?.style.setProperty('display', 'block');
              this.descriptions[index]?.style.setProperty('display', 'block');
            } else {
              this.keys[index]?.style.setProperty('display', 'none');
              this.descriptions[index]?.style.setProperty('display', 'none');
            }
          });
        }

      }

    }
  );
}
